import { render } from "./Workorder_GDGD.vue?vue&type=template&id=1f7ab243"
import script from "./Workorder_GDGD.vue?vue&type=script&lang=js"
export * from "./Workorder_GDGD.vue?vue&type=script&lang=js"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__